import React from "react";
import { isIntegerControl, rankWith } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";

export const materialIntegerControl = (props) => {
  if (!props.visible) {
    return null;
  }

  return (
    <>
      <strong>{props.label}:</strong>&nbsp;
      {props.data}
    </>
  );
};

export const materialIntegerControlTester = rankWith(3, isIntegerControl);
export default withJsonFormsControlProps(materialIntegerControl);
